'use client';

import BackgroundImage from '@components/background-image/BackgroundImage';
import ParallaxMedia from '@components/parallax-media/ParallaxMedia';
import sportImg from '@images/renders/infrastructure_images/Infra_Desktop_Webp/sport.webp';
import { handleStartPanoramaPreload } from '@lib/store/slices/ComponentsSlice';
import { ScrollTrigger } from '@lib/tools/gsap-init';
import { showAnimate } from '@lib/tools/utils';
import { useLayoutEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import style from './FifthScreenInfra.module.scss';

function FifthScreenInfra({ isMobile }) {
  const dispatch = useDispatch();
  const svgRef = useRef(null);
  const titleRef = useRef(null);
  const boxRef = useRef(null);

  useLayoutEffect(() => {
    if (svgRef) {
      let st5 = null;
      const element = svgRef.current;

      setTimeout(() => {
        st5 = ScrollTrigger.create({
          trigger: element,
          start: 'top top', // end: "bottom bottom",
          scroller: !isMobile ? '#smooth-wrapper' : 'body',
          scrub: true,
          pin: false,
          onToggle: () => {
            setTimeout(() => {
              dispatch(handleStartPanoramaPreload(true));
            }, 500);
          },
        });

        showAnimate(titleRef, titleRef.current);
        showAnimate(boxRef, boxRef.current);

        return () => {
          st5.kill();
        };
      }, 300);
    }
  }, [svgRef, isMobile]);

  return (
    <div data-scroll className={style.thirdScreenContainer} ref={svgRef} id='five'>
      <BackgroundImage className={style.thirdScreenImg} src={sportImg} name='bgr_3' imagePlug='' />

      <div className={style.gradient} />

      <div ref={titleRef} className={style.thirdScreenTitle}>
        <p className='will-show'>Вся семья</p>
        <p className='will-show'>на спорте</p>
      </div>
      <div ref={boxRef} className={style.thirdScreenDescription}>
        <p className='will-show'>
          {' '}
          Для здорового и&nbsp;спортивного образа жизни всё есть:
          <br />
          зелёные спортивные площадки и&nbsp;зоны для функциональных тренировок, настольного тенниса,
          <br /> баскетбол, лужайки для йоги и&nbsp;медитаций.
        </p>
      </div>
      <div className={style.thirdScreenLowContainer} data-scroll data-scroll-speed='-0.5' data-scroll-target='#five'>
        <div className={style.thirdScreenLowContainerTextWrapper}>
          <p>
            Предпочитаете длинные пробежки и&nbsp;велопрогулки? Стартуйте и&nbsp;финишируйте красиво&nbsp;&mdash;
            велодорожки по&nbsp;всему парку Покровское-Стрешнево.
          </p>
          <p>
            Велостоянки предусмотрены везде, где захочется остановить мгновение или перейти на&nbsp;прогулочный шаг.
          </p>
        </div>

        <ParallaxMedia
          dataScroll={true}
          dataScrollSpeed='-0.5'
          data-scroll-target='#five'
          video='/videos/autumn-pond.mp4'
          className={style.fifthScreenImgSmall}
          isVideo={true}
        />
      </div>
    </div>
  );
}

export default FifthScreenInfra;
